import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Config from '../../../config/config';
import ApiUiController from '../../../controller/ApiUiController';
import Util from '../../../util/Util';

class OzonetelPreview extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = { inApiCall: true };
    this.api = { name: '', method: Const.True, access_token: '', api_data: [] };
    this.models = reactLocalStorage.getObject(Const.Model);
    this.users = this.models.user.options;
    this.model = this.models.lead;
  }

  componentDidMount() {
    ThirdPartyAPI.get(this.id, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = api => {
    api.api_data = JSON.parse(api.api_data);
    this.api = api;
    this.setState({ ...this.state, inApiCall: false });
  };

  render() {
    const settings = this.api.api_data.map((setting, i) =>
      <tr key={`assign_${i}`}>
        <td>{i + 1}</td>
        <td>{this.users.find(user => user.value === setting.user).label}</td>
        <td>{setting.apiKey}</td> <td>{setting.username}</td> <td>{setting.phone}</td>
      </tr>
    );

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="row mb-6">
              <div className="col-md-6 pb-3"><h3>{this.api.name}</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered >
                  <thead>
                    <tr><th>Method</th><th>URL</th><th>Headers</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{this.api.method === Const.True ? 'POST' : 'GET'}</td>
                      <td>
                        {`${Config.app.link}api/hit/${this.models.api_key}/${this.api.access_token}`}
                      </td>
                      <td>
                        Access-Control-Allow-Origin : *
                        <br />Content-Type : application/json
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 pb-3"><h6>Settings</h6></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><th>Sr</th><th>User</th><th>Api key</th><th>Username</th>
                    <th>Phone</th></tr></thead>
                  <tbody>{settings}</tbody>
                </Table>
              </div>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(OzonetelPreview);
